// Module
var code = "<div id=\"viewerContainer\" style=\"overflow: auto;\n       position: absolute;\n         width: 100%;\n        height: 100%;\">\n    <div id=\"viewer\" class=\"pdfViewer\"></div>\n</div>\n";
// Exports
module.exports = code;